import { Button } from '@fluentui/react-components'
import { AddRegular, ChatRegular, DeleteRegular } from '@fluentui/react-icons'
import type { ConversationSummary } from '@/types/conversation'
import styles from './ConversationHistory.module.css'

interface ConversationHistoryProps {
  conversations: ConversationSummary[]
  activeConversationId: string | null
  disabled?: boolean
  onNew: () => void
  onSelect: (id: string) => void
  onDelete: (id: string) => void
}

/**
 * Left rail listing the signed-in user's persisted conversations, with a
 * button to start a fresh one. Selecting an entry loads its transcript.
 */
export function ConversationHistory({
  conversations,
  activeConversationId,
  disabled,
  onNew,
  onSelect,
  onDelete,
}: ConversationHistoryProps) {
  return (
    <aside className={styles.root} aria-label="Istoric conversații">
      <div className={styles.header}>
        <Button
          appearance="primary"
          icon={<AddRegular />}
          onClick={onNew}
          disabled={disabled}
          className={styles.newButton}
        >
          Conversație nouă
        </Button>
      </div>

      <nav className={styles.list}>
        {conversations.length === 0 ? (
          <p className={styles.empty}>Nu există conversații salvate încă.</p>
        ) : (
          conversations.map((conversation) => {
            const isActive = conversation.id === activeConversationId
            return (
              <div
                key={conversation.id}
                className={`${styles.item} ${isActive ? styles.itemActive : ''}`}
              >
                <button
                  type="button"
                  className={styles.itemButton}
                  onClick={() => onSelect(conversation.id)}
                  disabled={disabled}
                  title={conversation.title}
                >
                  <ChatRegular className={styles.itemIcon} />
                  <span className={styles.itemTitle}>{conversation.title}</span>
                </button>
                <Button
                  appearance="subtle"
                  size="small"
                  icon={<DeleteRegular />}
                  className={styles.deleteButton}
                  aria-label={`Șterge conversația „${conversation.title}”`}
                  disabled={disabled}
                  onClick={() => onDelete(conversation.id)}
                />
              </div>
            )
          })
        )}
      </nav>
    </aside>
  )
}
